import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { clsx } from 'clsx';
import { Collapse } from '@crehana/compass.ui';
import { Clamp } from '@crehana/ui';
import { handleNavigation } from "../../../shared/utils";
import CollapsedLink from "./CollapsedLink";
import MenuDesktopLink from "./MenuDesktopLink";
import SubMenuDesktopLink from "./SubMenuDesktopLink";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var LinkWithDropdown = function LinkWithDropdown(_ref) {
  var menuLink = _ref.menuLink,
    isDark = _ref.isDark,
    _onClickItem = _ref.onClickItem,
    sidebarCollapsed = _ref.sidebarCollapsed,
    currentActive = _ref.currentActive,
    centralizedId = _ref.centralizedId,
    userRole = _ref.userRole;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var _menuLink$nested = menuLink.nested,
    nested = _menuLink$nested === void 0 ? [] : _menuLink$nested,
    _menuLink$defaultOpen = menuLink.defaultOpen,
    defaultOpen = _menuLink$defaultOpen === void 0 ? false : _menuLink$defaultOpen;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSubmenuExpanded = _useState4[0],
    setIsSubmenuExpanded = _useState4[1];
  useEffect(function () {
    if (currentActive && nested.find(function (link) {
      return link.code === currentActive.code;
    })) setIsSubmenuExpanded(true);
  }, [currentActive, nested]);
  var Icon = menuLink.activeIcon || menuLink.icon;
  useEffect(function () {
    if (defaultOpen) {
      var timeout = setTimeout(function () {
        setIsSubmenuExpanded(true);
      }, 120);
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [defaultOpen]);
  if (sidebarCollapsed) {
    return /*#__PURE__*/_jsx(CollapsedLink, {
      isDark: isDark,
      menuLink: menuLink,
      isOpened: isSubmenuExpanded,
      onClickOutside: function onClickOutside() {
        setIsSubmenuExpanded(false);
      },
      isHovered: isHovered,
      onMouseEnter: function onMouseEnter() {
        return setIsHovered(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setIsHovered(false);
      },
      onClickItem: _onClickItem,
      toggleDropdown: function toggleDropdown() {
        setIsSubmenuExpanded(function (prev) {
          return !prev;
        });
      },
      currentActive: currentActive
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(MenuDesktopLink, {
      isSelected: isSubmenuExpanded,
      toggleDropdown: function toggleDropdown() {
        setIsSubmenuExpanded(function (prev) {
          return !prev;
        });
      },
      onMouseEnter: function onMouseEnter() {
        return setIsHovered(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setIsHovered(false);
      },
      isHovered: isHovered,
      children: [/*#__PURE__*/_jsx(Icon, {
        size: 16,
        className: clsx('tw-fill-current tw-w-2.4 tw-min-w-2.4 tw-max-h-2.4', isSubmenuExpanded || isHovered ? ' tw-text-primary-light-500 dark:tw-text-secondary-dark-400' : 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-300'),
        ignoreColor: true
      }), /*#__PURE__*/_jsx(Clamp, {
        clamp: 1,
        title: menuLink.label.length > 20 ? menuLink.label : undefined,
        className: clsx('tw-ml-0.8 tw-break-all tw-font-subtitle5 ', isSubmenuExpanded && !isHovered && 'tw-text-neutral-dark-700', isHovered ? 'tw-text-primary-light-500' : 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-300'),
        children: menuLink.label
      })]
    }, menuLink.code), /*#__PURE__*/_jsx(Collapse, {
      open: isSubmenuExpanded,
      children: /*#__PURE__*/_jsx("ul", {
        className: "tw-block tw-w-full tw-pt-0.4",
        children: nested.map(function (subRoute) {
          return /*#__PURE__*/_jsx(SubMenuDesktopLink, {
            code: subRoute.code,
            label: subRoute.label,
            url: subRoute.url,
            isDark: isDark,
            isSelectedURL: Boolean(currentActive && currentActive.code === subRoute.code),
            onClickItem: function onClickItem() {
              if (_onClickItem) {
                handleNavigation({
                  url: subRoute.url || '',
                  centralizedId: centralizedId || '',
                  userRole: userRole,
                  onClickItem: _onClickItem,
                  openInNewTab: false
                });
              }
            }
          }, subRoute.code);
        })
      })
    })]
  });
};
export default LinkWithDropdown;